import {
  getBottomSpace,
  getStatusBarHeight,
} from 'react-native-iphone-screen-helper';
import {Platform} from 'react-native';
import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';
import FontAwesome from 'react-native-vector-icons/FontAwesome';
import {css} from 'styled-components/native';

interface Check {
  checked?: boolean;
}

export const Container = styled.View`
  background-color: ${({theme}) => theme.colors.background};
  flex: 1;
`;

export const Content = styled.View`

`;

export const ContentHeader = styled.View`
  padding: 0 24px;
`;

export const Form = styled.View`
  margin: 0 24px;
`;

export const InputGroup = styled.View`
  margin-bottom: ${RFValue(12)}px;
`;

export const InputRow = styled.View`
  flex-direction: row;
  align-items: center;
`;

export const Input = styled.TextInput`
  background-color: #000;
`;

export const Footer = styled.View`
  padding: 0 24px;
  padding-top: ${RFValue(6)}px;
  padding-bottom: ${Platform.OS === 'ios' && getBottomSpace()
    ? 0
    : RFValue(20)}px;
  width: 100%;
`;

export const StatusBarMask = styled.View`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: ${getStatusBarHeight() + RFValue(12)}px;
  background-color: ${({theme}) => theme.colors.background};
  z-index: 2;
`;

export const LabelContainer = styled.View`
  gap: ${RFValue(6)}px;
`;

export const LabelTitle = styled.Text`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const Label = styled.Text`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text};
  font-family: ${({theme}) => theme.fonts.regular};
  margin-left: ${RFValue(12)}px;
`;

export const LabelBold = styled(Label)`
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const TermTitle = styled.Text`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.title};
  margin-top: -1px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const TermContainer = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: ${RFValue(12)}px;
`;

export const TermLinkButton = styled.TouchableOpacity`
  border-bottom-width: 2px;
  border-color: ${({theme}) => theme.colors.blue};
  border-style: solid;
`;

export const TermLinkText = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.blue};
`;

export const TermCheckButton = styled.TouchableOpacity`
  flex-direction: row;
  align-items: center;
  gap: ${RFValue(6)}px;
`;

export const TermContainerBox = styled.View`
  flex-direction: column;
`;

export const TermCheckIcon = styled(FontAwesome)<Check>`
  font-size: ${RFValue(20)}px;
  color: ${({theme}) => theme.colors.text};
  ${({checked, theme}) =>
    checked &&
    css`
      color: ${theme.colors.blue};
    `}
`;

export const SectionScroll = styled.ScrollView`
  margin: 0 -24px;
`;

export const Section = styled.View`
  margin-bottom: ${RFValue(12)}px;
`;

export const SectionTitle = styled.Text`
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(14)}px;
  padding: 0 24px;
  margin-bottom: ${RFValue(6)}px;

  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const JustificativaContainer = styled.View`
  height: ${RFValue(50)}px;
  border-style: solid;
  border-bottom-width: 1px;
  border-bottom-color: ${({theme}) => theme.colors.border};
  margin-bottom: ${RFValue(12)}px;
`;

export const RadioOptionsList = styled.View`
  gap: ${RFValue(8)}px;
  margin-top: ${RFValue(8)}px;
`;

interface RadioOptionProps {
  selected?: boolean;
}

export const RadioOptionItem = styled.TouchableOpacity<RadioOptionProps>`
  flex-direction: row;
  align-items: center;
  border-width: 1px;
  border-color: ${({selected, theme}) =>
    selected ? theme.colors.blue : '#767676'};
  border-radius: ${RFValue(8)}px;
  padding: ${RFValue(12)}px ${RFValue(14)}px;
  gap: ${RFValue(12)}px;
`;

export const RadioOptionIcon = styled(FontAwesome)<Check>`
  font-size: ${RFValue(18)}px;
  color: ${({theme}) => theme.colors.text};
  ${({checked, theme}) =>
    checked &&
    css`
      color: ${theme.colors.blue};
    `}
`;

export const RadioOptionTextContainer = styled.View`
  flex: 1;
  gap: ${RFValue(2)}px;
`;

export const RadioOptionLabel = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.title};
`;

export const RadioOptionDescription = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(11)}px;
  color: ${({theme}) => theme.colors.text};
`;
export const JustificativaLabel = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.title};
`;

export const JustificativaInput = styled.TextInput.attrs(({theme}) => ({
  placeholderTextColor: theme.colors.placeholder,
}))`
  height: ${RFValue(40)}px;
  flex: 1;
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text_dark};
`;
